export default {"src":"/_next/static/media/Facebook.7851d6d4.svg","height":28,"width":28};